import Head from "next/head";
import ListPromosi from "../../../components/publikasi/ListPromosi";
import Loading from "../../../components/Loading";
import { getEventsPublications } from "../../../service/useEventsPublications";

export async function getServerSideProps(context) {
  const { data, fetching, error } = await getEventsPublications({
    category: "e-brocure",
    limit: null,
    page: null,
  });

  if (error) {
    return {
      props: {
        data: null,
        total: 0,
        fetching: false,
      },
    };
  }

  const temps = [];
  for (const item of data.cms_promotions) {
    temps.push({
      link: item.link,
      id: item.id,
      url: item.url,
      program: item.program,
      title: item.title,
      description: item.description,
      created_at: item.created_at,
    });
  }

  return {
    props: {
      data: temps || null,
      fetching: fetching || null,
    },
  };
}

export default function index({ data, fetching }) {
  const schemeData = {
    "@type": "E-Brocure",
    data: data,
  };

  return (
    <main className="h-full w-full bg-[#F3F7FA]">
      <Head>
        <title>E-Brocure | Wardaya Online by Wardaya College</title>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schemeData),
          }}
        />
      </Head>

      <div className="mx-auto flex w-full max-w-[1260px] flex-col items-center px-4 pt-24 md:pt-36">
        <h1 className="bg-gradient-to-tr from-[#024D88] to-[#006ABE] bg-clip-text font-nunito text-2xl font-black text-transparent md:text-4xl">
          E-Brocure
        </h1>

        <div className="mx-auto flex max-w-[1280px] flex-col px-3">
          <div className="mt-12 w-full pb-24">
            <ul className="grid grid-cols-2 gap-2 md:gap-5 lg:grid-cols-4">
              {data?.map((item) => (
                <ListPromosi
                  key={item.id}
                  title={item.title}
                  description={item.description}
                  image={"/images/logo.png"}
                  url={item.url}
                />
              ))}
            </ul>
          </div>
        </div>
      </div>

      {fetching ? (
        <div className="fixed top-0 left-0 z-[150] flex h-screen w-screen items-center justify-center bg-black bg-opacity-10">
          <Loading fillcolor={"#EA374C"} />
        </div>
      ) : null}
    </main>
  );
}
